import { render, staticRenderFns } from "./canvasAcircle.vue?vue&type=template&id=2890da33&scoped=true&"
import script from "./canvasAcircle.vue?vue&type=script&lang=js&"
export * from "./canvasAcircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890da33",
  null
  
)

export default component.exports